module.exports = __webpack_public_path__ + "static/media/bib_logo.2aafc829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bib_logo.png
// module id = 313
// module chunks = 0